module.exports = __webpack_public_path__ + "img/jk_14.5e5963af.png";